/**
 * One visual vocabulary for every event object in this widget — the timeline
 * bars and the list cells.
 *
 * Design rule: the widget is neutral at rest. The *only* saturated signals are:
 *   cyan  → "this is what the dashboard is scoped to" (the active filter)
 *   error → the alert-triangle icon + count, inline in the row
 *
 * Surfaces never turn red/orange for anomalies — that job belongs to the
 * triangle icon rendered inside the row, not to the row background.
 */

/** Surface + border for an event object, by state. */
export function eventSurface({ selected }: { selected: boolean }): string {
  if (selected) return 'border-brand-cyan/50 bg-brand-cyan/[0.06]';
  return 'border-border bg-surface-elevated hover:border-border hover:bg-surface-elevated';
}

/** The event name, emphasised when live or selected. */
export function eventLabel(strong: boolean): string {
  return `min-w-0 flex-1 truncate text-sm leading-tight tracking-tight ${
    strong ? 'font-semibold text-primary' : 'font-medium text-secondary group-hover:text-primary'
  }`;
}
